import { SponsorLogoAndText } from "components/eventCard/talkElements";
import { formatDateEventCard } from "components/eventCard/utils";
import type { TalkData } from "content-ui/talks/types";

export const TalkInfoCard = ({
  talk,
  allTalks,
}: {
  talk: TalkData;
  allTalks?: TalkData[];
}) => {
  const talkTime = new Date(talk.dateTime);
  const talkDuration = talk?.duration * 60 * 1000;
  const endTime = new Date(talkTime.getTime() + talkDuration);
  const isTalkEnded = Date.now() >= endTime.getTime();

  return (
    <div className={"flex flex-none flex-col gap-[10px]"}>
      {/* TODO: remove / refactor isInPerson behaviour - this is a hack made due to a very last minute request by marketing */}
      {talk.isInPerson ? null : (
        <>
          <h3 className={"font-bold text-[16px] leading-[130%]"}>
            Date & Venue
          </h3>
          <p className={"text-[16px] leading-[130%] text-mono-70"}>
            {formatDateEventCard(new Date(talk.dateTime), {
              timezone: ["Europe/London", "Europe/Brussels"],
              withDuration: false,
              duration: talkDuration,
            })}
          </p>
          <p className={"flex flex-col gap-[6px]"}>
            <span className="text-[16px] leading-[130%] text-mono-70">
              Virtual (Zoom call)
            </span>
          </p>
        </>
      )}
      {talk.sponsorLogo && !isTalkEnded ? (
        <>
          <SponsorLogoAndText
            image={talk.sponsorLogo}
            variant="singlePage"
            sponsorDetails={talk.sponsorDetails}
          />
        </>
      ) : null}
    </div>
  );
};
